export default "__VITE_ASSET__CBrtlbUW__"